import * as React from 'react';
import { Button, Form, Header, GridRow, Segment } from 'semantic-ui-react';

import configs from '../helpers/config';
import "../helpers/styles.css";

class SolicitarSenha extends React.Component {
    constructor(props) {
        super(props);
        this.state = { email: '' };
    }

    handleLogin() {
        const { email } = this.state;
        const regexEmail = (/\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/);
        if (regexEmail.test(email)) {
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(configs.RECAPTCHA_SITE_KEY, { action: 'PortalResultadosSolicitarSenha' }).then(token => {
                    this.setState({ recaptcha_token: token });
                    this.props.onClick({ ...this.state });
                });
            });
        } else {
            alert('Email informado é inválido');
        }
    }

    render() {
        return (
            <Segment className={this.props.className}>

                <Header as='h2'  >

                    <p className='headerLogin'>Recuperar senha</p>
                </Header>

                <Form size='large'>
                    <GridRow >
                        <Form.Input
                            fluid
                            icon='at'
                            iconPosition='left'
                            placeholder='Email'
                            value={this.state.email}
                            onChange={(e) => this.setState({ email: e.target.value })}
                        />

                        <Button fluid size='large' onClick={() => this.handleLogin()}>
                            Recuperar
                        </Button >
                    </GridRow>
                </Form>

            </Segment>);
    }
}

export default SolicitarSenha;
